// React imports
import { useEffect, useState } from 'react';

// Components
import ModalContent from '../components/ModalContent.tsx';
import ScrollToTop from '../components/ScrollToTop.tsx';

// Contextes
import Container from '../components/Container.tsx';
import { useInTheGame } from '../utils/InTheGameContexte.tsx';

// Librairies
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

// Data
import mentionsLegalesData from '../data/mentionslegales.ts';

function MentionsLegales() {
    // Toggle Game pour afficher le logo
    const { toggleGame } = useInTheGame();
    useEffect(() => {
        toggleGame(true);
    }, [toggleGame]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [linkHref, setLinkHref] = useState('');

    // Fonction pour gérer la confirmation avant de quitter la page
    const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        // Empêcher la navigation par défaut
        e.preventDefault();
        setLinkHref(e.currentTarget.href);
        setIsModalOpen(true);
    };

    return (
        <>
            <ModalContent
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                linkHref={linkHref}
            />
            <Container color='white'>
                <section id='mentionsLegalesTitles'>
                    <h1 className='text-special text-special--red'>Mentions légales</h1>
                    {mentionsLegalesData.map((mention, index) => (
                        <article
                            key={`{${index}--article}`}
                            className='mentionsLegales'
                        >
                            <h2
                                className={`text-special text-special--blue mentionsLegales__subtitle`}
                            >
                                {mention.title}
                            </h2>
                            <ReactMarkdown
                                rehypePlugins={[rehypeRaw]}
                                components={{
                                    p: ({ ...props }) => <p {...props} />,
                                    a: ({ ...props }) => (
                                        <a
                                            {...props}
                                            className='custom-link mentionsLegales__link'
                                            onClick={handleLinkClick}
                                        />
                                    ),
                                }}
                            >
                                {mention.content}
                            </ReactMarkdown>
                        </article>
                    ))}
                    <ScrollToTop sectionId='mentionsLegalesTitles' />
                </section>
            </Container>
        </>
    );
}

export default MentionsLegales;
